import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { RequestFilter } from '../../models/RequestFilter.model';
import { RequestDetail } from 'src/app/shared/models/requestDetail.model';
import { UtilService } from '../../architecture/services/util.service';
import { InsertRequest } from '../../models/insertRequest.model';
import { RequestBank } from '../../models/requestBank.model';
import { BankRequest } from '../../models/bankRequest.model';
import { RequestPopid } from '../../models/requestPopid.model';
import { RequestFollowUp } from '../../models/requestFollowup.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestService {
    constructor(private dataService: DataService,
        private utilService: UtilService) { }

    public getFollowUp(id: number) {
        return this.dataService.get<Result<RequestFollowUp>>('request/followup/' + id);
    }

    public getRequestBank(id: number) {
        return this.dataService.get<Result<RequestBank>>('request/' + id + '/bank');
    }

    public getRequestDetailValues(id: number) {
        return this.dataService.get<Result<RequestDetail>>('request/detailvalues/' + id);
    }

    public getRequestHistory(id: number) {
        return this.dataService.get<Result<any>>('request/history/' + id);
    }

    public getAuthorization(id: number) {
        return this.dataService.get<Result<any>>('request/authorization/' + id);
    }

    public get(page: number, order: string, orderT: string, filter: RequestFilter) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.pageSize', "5")
            .set('filter.entity.id', filter.id ? filter.id.toString() : "0")
            .set('filter.entity.clientId', filter.clientId)
            .set('filter.entity.negRef', filter.negRef)
            .set('filter.entity.popId', filter.popId ? filter.popId.toString() : '0')
            .set('filter.entity.status', filter.status)
            .set('filter.entity.manager', filter.manager)
            .set('filter.entity.frontOffice', filter.frontOffice)
            .set('filter.entity.startDate', filter.startDate)
            .set('filter.entity.endDate', filter.endDate)
            .set('filter.entity.credit', filter.credit)
            .set('filter.entity.dealer', filter.dealer)
            .set('filter.entity.pac', filter.pac)
            .set('filter.entity.negId', filter.negId ? filter.negId.toString() : '0')
            .set('filter.orderByField', order)
            .set('filter.orderBy', orderT)
            .set('filter.entity.authorizedToConfirm', filter.authorizedToConfirm ? 'true' : 'false');

        return this.dataService.get<Result<any>>("request", params);
    }

    public generateFile(filter: RequestFilter) {
        let body = {
            entity: {
                id: filter.id ? filter.id.toString() : "0",
                clientId: filter.clientId,
                negRef: filter.negRef,
                popId: filter.popId ? filter.popId.toString() : '0',
                status: filter.status,
                manager: filter.manager,
                frontOffice: filter.frontOffice,
                startDate: filter.startDate,
                endDate: filter.endDate,
                credit: filter.credit,
                dealer: filter.dealer,
                pac: filter.pac,
                negId: filter.negId ? filter.negId.toString() : '0',
                authorizedToConfirm: filter.authorizedToConfirm
            }
        };

        this.utilService.DownloadFile("request/generatefile", "solicitacao.xlsx", body);
    }

    public getPopId(requestId: number) {
        return this.dataService.get<Result<any>>('request/popid/' + requestId);
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<any>>('request/' + cod.toString());
    }

    public deleteBank(cod: number, bankCod: number) {
        return this.dataService.delete<Result<any>>('request/' + cod + '/bank/' + bankCod);
    }

    public deletePopId(popId: RequestPopid) {
        let obj = {
            requestId: popId.requestId,
            seq: popId.seq,
            popId: popId.popId,
            forecast: popId.forecast,
            value: popId.value
        };

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            body: obj
        };

        return this.dataService.deleteAny<Result<any>>('request/popid', httpOptions);
    }

    public deleteFollowUp(requestFollowup: RequestFollowUp) {
        let obj = {
            requestId: requestFollowup.requestId,
            seq: requestFollowup.seq,
            bankId: requestFollowup.bankId,
            pac: requestFollowup.controlPacNumber,
            sitCredit: requestFollowup.sitCred
        };

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            body: obj
        };

        return this.dataService.deleteAny<Result<any>>('request/followup', httpOptions);
    }

    public updatePopId(cod: number, popIdRequest: RequestPopid) {
        return this.dataService.put<Result<RequestPopid>>('request/popid', popIdRequest);
    }

    public insertPopId(cod: number, popIdRequest: RequestPopid) {
        return this.dataService.post<Result<RequestPopid>>('request/popid', popIdRequest);
    }

    public updateBank(cod: number, bankRequest: BankRequest) {
        return this.dataService.put<Result<BankRequest>>('request/' + cod + '/bank', bankRequest);
    }

    public insertBank(cod: number, bankRequest: BankRequest) {
        return this.dataService.post<Result<BankRequest>>('request/' + cod + '/bank', bankRequest);
    }

    public insertFollowUp(followupRequest: any): Observable<Result<RequestFollowUp>> {
        return this.dataService.post<Result<RequestFollowUp>>('request/followup', followupRequest);
    }

    public updateFollowUp(followupRequest: any): Observable<Result<RequestFollowUp>> {
        return this.dataService.put<Result<RequestFollowUp>>('request/followup', followupRequest);
    }

    public update(requestDetail: RequestDetail) {
        return this.dataService.put<Result<RequestDetail>>('request', requestDetail);
    }

    public insert(request: InsertRequest) {
        return this.dataService.post<Result<any>>('request', request);
    }

    public saveFile(requestId: number, seq: number, file: FormData): Observable<Result> {
        return this.dataService.post('request/' + requestId + '/followup/' + seq + '/insertfile', file);
    }

}
